const ProtectedLayout = ({ children }) => {
  return (
    <> <main className=" pt-16">{children}</main> </>
  );
};
export default ProtectedLayout;